import React, { useEffect, useRef } from "react";
import { Spinner, Stack, Text } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { Installments, Atol, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownFlightCardPriceController,
  type UnifiedPriceBreakdownFlightCardPriceControllerProps
} from "./useUnifiedPriceBreakdown.FlightCardPrice.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownFlightCardPriceProps = UnifiedPriceBreakdownFlightCardPriceControllerProps;

export function UnifiedPriceBreakdownFlightCardPrice(props: UnifiedPriceBreakdownFlightCardPriceProps) {
  const {
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    isFlightDetailsLoading,
    unifiedPriceBreakdown,
    expandedByDefault,
    flightDetailsLoadingText,
    addedItems,
    routeName
  } = useUnifiedPriceBreakdownFlightCardPriceController(props);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { grumble } = useEvents();

  useEffect(() => {
    // force BUI popover to re-calculate position
    if (!wrapperRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      window.dispatchEvent(new Event("resize"));
    });
    resizeObserver.observe(wrapperRef.current);
    return () => resizeObserver.disconnect();
  }, [wrapperRef]);

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "FlightCardPrice", routeName });
    return null;
  }

  return (
    <Stack gap={4} attributes={{ ref: wrapperRef }}>
      {isFlightDetailsLoading ? (
        <>
          <Stack direction="row">
            <Spinner size="small" />
            <Text>{flightDetailsLoadingText}</Text>
          </Stack>
          <Breakdown
            addedItems={[]}
            items={[]}
            footerSections={{}}
            isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
            price={unifiedPriceBreakdown.price}
            isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
          />
        </>
      ) : (
        <>
          <Breakdown
            {...unifiedPriceBreakdown}
            isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
            expandedByDefault={expandedByDefault}
            isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
            addedItems={addedItems}
          />
          <Disclaimers disclaimers={disclaimers} />
        </>
      )}
      <Atol />
      <Installments />
    </Stack>
  );
}
